import React from 'react'
import PrintSvg from 'images/modules/Manage/i-print.svg?raw'

export { default as PrintUrl } from 'images/modules/Manage/i-print.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: PrintSvg}} />
)
